import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  access_token: null,
  refresh_token: null,
  picker_token: null as string | null,
  workspaces: [] as any[],
  user: null,
  accesses: null,
  inspection_companies: [],
  company: undefined,
  isExpiredCompanyAPIcalling: false,
  active_inspection_company: undefined,
  expired_inspection_company: undefined,
  sectors: [],
  teamSizeList: [],
  subscriptionPlans: [],
  isOpenSuccessDialog: false,
  isEnterprisePlanDialog: false,
  isLoading: false,
  isPageLoading: false,
  tcc_balance: 0,
  isVisibleTCCcard: false,
  subscription_renew_check: null,
  renew_company_id: null,
  isOTPMode: false,
  isOTPSentMode: false,
  mode: undefined,
  isPhoneVerifyDialog: false,
  isEmailVerifyDialog: false,
  isInOTPPage: false,
  temporaryPassword: undefined,
  /** Last OTP send metadata from API (channel + fallback reason). */
  otpDelivery: null as {
    requestedChannel: 'email' | 'mobile'
    actualChannel: 'email' | 'sms'
    fallbackReason: string | null
  } | null,
}

export const AuthSlices = createSlice({
  name: 'auth',
  initialState: initialState,
  reducers: {
    login: (state: any, action: any) => {
      state.user = action.payload.user
    },

    setPickerData: (state: any, action: any) => {
      state.picker_token = action.payload.picker_token
      state.workspaces = action.payload.workspaces
      state.user = action.payload.user
    },

    setWorkspaceAuth: (state: any, action: any) => {
      state.access_token = action.payload.access_token
      state.picker_token = null
      state.workspaces = []
      state.user = action.payload.user
      state.inspection_companies = action.payload.inspection_companies ?? state.inspection_companies
      state.active_inspection_company = action.payload.active_inspection_company ?? state.active_inspection_company
      state.company = action.payload.active_inspection_company ?? state.company
    },

    manageUserData: (state: any, action: any) => {
      state.access_token = action.payload.user.access_token
      state.refresh_token = action.payload.user.refresh_token
      state.inspection_companies = action.payload.inspection_companies
      const defaultCompany = action.payload.inspection_companies?.length > 0 ? action.payload.inspection_companies[0] : null
      state.active_inspection_company = action.payload.active_inspection_company || defaultCompany
      state.user = action.payload.user
      state.company = action.payload.active_inspection_company || defaultCompany
    },

    userAccess: (state: any, action: any) => {
      state.accesses = action.payload.accesses
    },

    registration: (state: any, action: any) => {
    },

    logout: (state: any) => {
      state.access_token = null
      state.picker_token = null
      state.workspaces = []
      state.user = null
      state.accesses = null
      state.refresh_token = null
      state.isExpiredCompanyAPIcalling = false
      state.active_inspection_company = undefined
      state.expired_inspection_company = undefined
      state.inspection_companies = []
      state.company = null
      state.tcc_balance = 0
      state.isVisibleTCCcard = false
      state.subscription_renew_check = null
      state.renew_company_id = null
      state.isPageLoading = false
      state.isOTPMode = false
      state.mode = undefined
      state.isOTPSentMode = false
      state.otpDelivery = null
    },

    deleteData: (state: any) => {
      state.access_token = null
      state.picker_token = null
      state.workspaces = []
      state.accesses = null
      state.refresh_token = null
      state.isExpiredCompanyAPIcalling = false
      state.active_inspection_company = undefined
      state.expired_inspection_company = undefined
      state.inspection_companies = []
      state.company = null
      state.tcc_balance = 0
      state.isVisibleTCCcard = false
      state.isOTPMode = false
      state.mode = undefined
      state.isOTPSentMode = false
      state.otpDelivery = null
    },

    deleteUser:  (state: any) => {
      state.user = null
    },

    updateUser: (state: any, action) => {
      state.user = { ...state.user, ...action.payload.user }
    },

    setActiveCompany: (state, action) => {
      state.active_inspection_company = action.payload
    },

    setIsExpiredCompanyAPIcalling: (state, action) => {
      state.isExpiredCompanyAPIcalling = action.payload
    },

    setExpiredCompany: (state, action) => {
      state.expired_inspection_company = action.payload
    },

    updateInspectionCompanies: (state, action) => {
      state.inspection_companies = state.inspection_companies.filter((item: any) => item.id !== action.payload.id)
    },

    getSectorList: (state, action) => {
      state.sectors = action.payload.sector
    },

    getTeamSizeList: (state, action) => {
      state.teamSizeList = action.payload.team
    },

    getSubscriptionPlanList: (state, action) => {
      state.subscriptionPlans = action.payload.subscription_plans
    },

    getSuccessDialog: (state, action) => {
      state.isOpenSuccessDialog = action.payload;
    },

    setLoadingState: (state, action) => {
      state.isLoading = action.payload;
    },

    getEnterprisePlanDialog: (state, action) => {
      state.isEnterprisePlanDialog = action.payload;
    },

    getCompany: (state, action) => {
      state.company = action.payload.inspection_company
    },

    getTCCBalance: (state, action) => {
      state.tcc_balance = action.payload.tcc_balance
    },

    setTCCBalanceCardStatus: (state, action) => {
      state.isVisibleTCCcard = action.payload;
    },

    setIsPageLoading: (state, action) => {
      state.isPageLoading = action.payload;
    },

    setInspectionCompanies: (state, action) => {
      state.inspection_companies = action.payload.inspection_companies;
    },

    setIsOTPMode: (state, action) => {
      state.isOTPMode = action.payload;
    },

    setOTPMode: (state, action) => {
      state.mode = action.payload;
    },

    setIsOTPSentMode: (state, action) => {
      state.isOTPSentMode = action.payload;
    },

    setIs: (state, action) => {
      state.isOTPSentMode = action.payload;
    },


    checkSubscriptionExpiry: (state, action) => {
      // @ts-ignore
      state.subscription_renew_check = action.payload.inspection_company;
    },

    renewCompanyId: (state, action) => {
      // @ts-ignore
      state.renew_company_id = action.payload
    },

    setPhoneNoVerifyDialogState: (state, action) => {
      state.isPhoneVerifyDialog = action.payload;
    },

    setEmailVerifyDialogState: (state, action) => {
      state.isEmailVerifyDialog = action.payload;
    },

    setIsInOTPPage: (state, action) => {
      state.isInOTPPage = action.payload;
    },

    setTemporaryPassword: (state, action) => {
      state.temporaryPassword = action.payload;
    },

    setOtpDelivery: (state, action) => {
      state.otpDelivery = action.payload;
    },
  },
})

export const { setActiveCompany, setTCCBalanceCardStatus, setWorkspaceAuth } = AuthSlices.actions
